module.exports = __webpack_public_path__ + "static/media/SR100-W2L0 Copy.98e4722d.png";